import { Tooltip } from 'antd';

export type TierCode = 'temel' | 'orta' | 'ileri';

interface TierBadgeProps {
  tier: TierCode | null | undefined;
  size?: 'sm' | 'md';
  showLabel?: boolean;
}

const tierMeta: Record<TierCode, { label: string; color: string; description: string }> = {
  temel: { label: 'Temel', color: 'var(--color-tier-temel)', description: 'Temel pakette yer alır' },
  orta: { label: 'Orta', color: 'var(--color-tier-orta)', description: 'Orta pakette yer alır' },
  ileri: { label: 'İleri', color: 'var(--color-tier-ileri)', description: 'İleri pakette yer alır' },
};

export function TierBadge({ tier, size = 'sm', showLabel = false }: TierBadgeProps) {
  if (!tier || !tierMeta[tier]) return null;
  const meta = tierMeta[tier];
  const dot = size === 'sm' ? 6 : 8;

  if (showLabel) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '2px 8px 2px 6px',
          borderRadius: 3,
          background: 'var(--color-hover-bg)',
          border: '1px solid var(--color-border)',
          fontSize: 10,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.7,
          color: meta.color,
        }}
      >
        <span
          aria-hidden
          style={{
            width: dot,
            height: dot,
            borderRadius: '50%',
            background: meta.color,
          }}
        />
        {meta.label}
      </span>
    );
  }

  return (
    <Tooltip title={meta.description} mouseEnterDelay={0.2}>
      <span
        aria-label={meta.description}
        style={{
          display: 'inline-block',
          width: dot,
          height: dot,
          borderRadius: '50%',
          background: meta.color,
        }}
      />
    </Tooltip>
  );
}
